import { footerData } from '@/mocks/homeData';

export default function Footer() {
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const id = href.replace('#', '');
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-sm">
                新
              </span>
              <span className="font-heading font-bold text-lg text-foreground-950">
                新新漫画
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed mb-4 max-w-xs">
              {footerData.description}
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-foreground-900 mb-4">
              快速导航
            </h4>
            <ul className="flex flex-col gap-2.5">
              {footerData.quickLinks.map((link, i) => (
                <li key={i}>
                  <a
                    href={link.href}
                    onClick={(e) => handleNavClick(e, link.href)}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer no-underline"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-foreground-900 mb-4">
              帮助支持
            </h4>
            <ul className="flex flex-col gap-2.5">
              {footerData.supportLinks.map((link, i) => (
                <li key={i}>
                  <a
                    href={link.href}
                    onClick={(e) => handleNavClick(e, link.href)}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer no-underline"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm text-foreground-900 mb-4">
              合作伙伴
            </h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              更多合作伙伴即将揭晓，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-10 md:mt-12 pt-6 border-t border-background-200/60">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs md:text-sm text-foreground-500">
              {footerData.copyright}
            </p>
            <p className="text-xs text-foreground-400">
              高清漫画在线阅读好选择 · 安全直达平台入口
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}